"use client";

import type { ReactNode } from "react";
import { DEFAULT_LOCALE, DEFAULT_TIME_ZONE, FORMATS } from "src/i18n/config";
import { IntlProvider } from "use-intl/react";
import { RenderedAtContext } from "./RenderedAtContext";

export interface AppIntlProviderProps {
  renderedAt?: number;
  children: ReactNode;
}

/** The app's intl context (one locale and time zone, formats) and the document's render time. */
const AppIntlProvider = (props: AppIntlProviderProps) => {
  const { renderedAt, children } = props;
  return (
    <RenderedAtContext value={renderedAt}>
      <IntlProvider
        locale={DEFAULT_LOCALE}
        timeZone={DEFAULT_TIME_ZONE}
        formats={FORMATS}
        // No catalog: `useExtracted` formats the message written in the call (one locale, see
        // vite/messageExtraction.ts), so no page loads all of messages/en.json.
      >
        {children}
      </IntlProvider>
    </RenderedAtContext>
  );
};

export default AppIntlProvider;
